var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      [
        _vm.purchase.actions.customer.supplementary_agreement === "sign"
          ? _c(
              "private-fl44-unknown-volume-supplementary-agreement-sign-form-customer",
              {
                attrs: {
                  purchase: _vm.purchase,
                  "supplementary-agreement": _vm.supplementaryAgreement,
                },
                on: {
                  refresh: function ($event) {
                    return _vm.$emit("refresh")
                  },
                },
              }
            )
          : _vm.purchase.actions.customer.supplementary_agreement === "reply"
          ? [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "10" } },
                    [
                      _c(
                        "text-header",
                        { attrs: { id: "atmo-disputes-resolution" } },
                        [
                          _vm._v(
                            "Согласование разногласий по дополнительному соглашению"
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-overlay",
                {
                  attrs: {
                    show: _vm.isDataSending,
                    opacity: "0.6",
                    rounded: "",
                    "spinner-small": "",
                    "spinner-variant": "primary",
                  },
                },
                [
                  _c("text-row-price", {
                    attrs: {
                      label: "Стоимость контракта",
                      compact: "",
                      "label-cols-lg": 4,
                    },
                    model: {
                      value: _vm.purchase.purchase_terms.contract_price,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.purchase.purchase_terms,
                          "contract_price",
                          $$v
                        )
                      },
                      expression: "purchase.purchase_terms.contract_price",
                    },
                  }),
                  _vm.supplementaryAgreement.type.id === "regular"
                    ? _c("form-row-edit-price", {
                        attrs: {
                          v: _vm.$v.formDisagreement.price,
                          label:
                            "Стоимость контракта с учетом дополнительного соглашения",
                          "label-cols-lg": 4,
                        },
                        model: {
                          value: _vm.formDisagreement.price,
                          callback: function ($$v) {
                            _vm.$set(_vm.formDisagreement, "price", $$v)
                          },
                          expression: "formDisagreement.price",
                        },
                      })
                    : [
                        _c(
                          "fl44-unknown-volume-supplementary-agreement-termination-specifications-edit-table",
                          {
                            attrs: { v: _vm.$v.formDisagreement.deliverables },
                            model: {
                              value: _vm.formDisagreement.deliverables,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formDisagreement,
                                  "deliverables",
                                  $$v
                                )
                              },
                              expression: "formDisagreement.deliverables",
                            },
                          }
                        ),
                        _vm.$v.formDisagreement.deliverables.$invalid
                          ? _c(
                              "b-form-invalid-feedback",
                              {
                                staticClass: "my-2",
                                staticStyle: {
                                  "padding-left": "5px",
                                  "padding-right": "5px",
                                },
                                attrs: {
                                  state:
                                    !_vm.$v.formDisagreement.deliverables
                                      .$invalid,
                                },
                              },
                              [_vm._v(_vm._s(_vm.specErrorMessage))]
                            )
                          : _vm._e(),
                        _c("text-row-price", {
                          attrs: {
                            label: "Общая стоимость, руб.",
                            value: _vm.specSum,
                            "label-cols-lg": 4,
                          },
                        }),
                      ],
                  _c("form-row-edit-date", {
                    attrs: {
                      label: "Дата заключения дополнительного соглашения",
                      v: _vm.$v.formDisagreement.conclusion_date,
                      "min-date":
                        _vm.purchase.contract.contract_conclusion_date,
                      "max-date": _vm.$now(),
                      "label-cols-lg": 4,
                    },
                    model: {
                      value: _vm.formDisagreement.conclusion_date,
                      callback: function ($$v) {
                        _vm.$set(_vm.formDisagreement, "conclusion_date", $$v)
                      },
                      expression: "formDisagreement.conclusion_date",
                    },
                  }),
                  _c("form-row-single-line-document-upload", {
                    attrs: {
                      v: _vm.$v.formDisagreement.attachment,
                      title: "Новая редакция дополнительного соглашения",
                      "label-cols-lg": 4,
                    },
                    model: {
                      value: _vm.formDisagreement.attachment,
                      callback: function ($$v) {
                        _vm.$set(_vm.formDisagreement, "attachment", $$v)
                      },
                      expression: "formDisagreement.attachment",
                    },
                  }),
                  _c("form-row-single-line-document-upload", {
                    attrs: {
                      v: _vm.$v.formDisagreement.disagreement,
                      title: "Ответ на протокол разногласий",
                      "label-cols-lg": 4,
                    },
                    model: {
                      value: _vm.formDisagreement.disagreement,
                      callback: function ($$v) {
                        _vm.$set(_vm.formDisagreement, "disagreement", $$v)
                      },
                      expression: "formDisagreement.disagreement",
                    },
                  }),
                  _c("form-row-edit-textarea", {
                    attrs: {
                      v: _vm.$v.formDisagreement.comment,
                      label: "Комментарий",
                      "label-cols-lg": 4,
                    },
                    model: {
                      value: _vm.formDisagreement.comment,
                      callback: function ($$v) {
                        _vm.$set(_vm.formDisagreement, "comment", $$v)
                      },
                      expression: "formDisagreement.comment",
                    },
                  }),
                ],
                2
              ),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-overlay",
                        {
                          staticClass: "d-inline-block",
                          attrs: {
                            show: _vm.isDataSending,
                            opacity: "0.6",
                            rounded: "",
                            "spinner-small": "",
                            "spinner-variant": "primary",
                          },
                        },
                        [
                          _c(
                            "b-btn",
                            {
                              staticClass: "mr-2 my-2",
                              attrs: {
                                disabled:
                                  !_vm.$store.getters.getCanSign ||
                                  _vm.$v.formDisagreement.$invalid,
                                variant: "custom-green",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.showDisagreementModal = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                "Подписать и отправить ответ на протокол разногласий"
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "fl44-unknown-volume-customer-sign-decline-supplementary-agreement-button",
                        {
                          staticClass: "mb-2",
                          attrs: {
                            purchase: _vm.purchase,
                            "supplementary-agreement":
                              _vm.supplementaryAgreement,
                          },
                          on: {
                            refresh: function ($event) {
                              return _vm.$emit("refresh")
                            },
                          },
                        }
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.$store.getters.getCanSign
                ? [
                    _vm.$store.getters.getLoginType === "cert"
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                          },
                          [
                            _vm._v(
                              "Для действия требуется загрузить/заменить МЧД на странице: "
                            ),
                            _c(
                              "router-link",
                              {
                                staticClass: "green-link",
                                attrs: { to: { name: "CabinetUserProfile" } },
                              },
                              [_vm._v("Данные учетной записи")]
                            ),
                          ],
                          1
                        )
                      : _c(
                          "span",
                          {
                            staticClass:
                              "text-danger pl-3 pt-0 fs-14 w-50 my-auto",
                          },
                          [
                            _vm._v(
                              "Подписание возможно только при авторизации при помощи ЭЦП"
                            ),
                          ]
                        ),
                  ]
                : _vm._e(),
              _vm.formDisagreement.disagreement
                ? _c("sign-file-modal", {
                    attrs: {
                      attachment: _vm.formDisagreement.disagreement,
                      show: _vm.showDisagreementModal,
                      "is-sending": _vm.isDataSending,
                      title:
                        "Отправка подписанного ответа на протокол разногласий",
                    },
                    on: {
                      close: function ($event) {
                        _vm.showDisagreementModal = false
                      },
                      submit: _vm.storeSignedDisagreement,
                    },
                  })
                : _vm._e(),
            ]
          : _vm.purchase.actions.customer.supplementary_agreement === "wait"
          ? _c(
              "fl44-unknown-volume-customer-sign-decline-supplementary-agreement-button",
              {
                staticClass: "mb-2",
                attrs: {
                  purchase: _vm.purchase,
                  "supplementary-agreement": _vm.supplementaryAgreement,
                },
                on: {
                  refresh: function ($event) {
                    return _vm.$emit("refresh")
                  },
                },
              }
            )
          : _vm._e(),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }